export const documentValidationsPerCountry = {
  AR: [
    {
      min: 7,
      max: 9,
      digits: true
    },
    {
      length: 11,
      digits: true
    }
  ],
  GT: [
    {
      min: 7,
      max: 13,
      digits: true
    }
  ],
  CR: [
    {
      min: 7,
      max: 9,
      digits: true
    }
  ],
  DO: [
    {
      min: 8,
      max: 11,
      digits: true
    }
  ],
  PA: [
    {
      min: 5,
      max: 8,
      digits: true
    }
  ],
  BO: [
    {
      min: 5,
      max: 20,
      digits: true
    }
  ],
  BR: [
    {
      min: 11,
      max: 14,
      digits: true,
    }
  ],
  CL: [
    {
      min: 8,
      max: 9,
      digits: true,
    }
  ],
  CO: [
    {
      min: 6,
      max: 10,
      digits: true,
    }
  ],
  EC: [
    {
      min: 5,
      max: 20,
      digits: true,
    }
  ],
  MX: [
    {
      min: 10,
      max: 18
    }
  ],
  PY: [
    {
      min: 5,
      max: 20,
      digits: true,
    }
  ],
  PE: [
    {
      min: 8,
      max: 9,
      digits: true,
    }
  ],
  UY: [
    {
      min: 6,
      max: 8,
      digits: true,
    }
  ],
  OTHER: [
    {
      min: 5,
      max: 20,
    }
  ]
};

export const getFieldOptions = (intl, translate) => {
  return {
    winsports: {
      pan: {
        showIcon: true,
        style: {
          base: {
            fontSize: '15px',
            fontFamily: 'Open Sans, sans-serif',
            lineHeight: '18px',
            fontSmoothing: 'antialiased',
            fontWeight: '500',
            color: '#fff',
            '::placeholder': {
              color: '#adb5bd',
              opacity: '0.9 !important',
              fontWeight: '500',
              fontFamily: 'Open Sans, sans-serif',
            },
            iconColor: '#fff',
          },
          autofilled: {
            color: '#adb5bd'
          }
        },
        placeholder: translate(intl, 'Form.placeholder.pan')
      },
      expiration: {
        style: {
          base: {
            fontSize: '15px',
            fontFamily: 'Open Sans, sans-serif',
            lineHeight: '18px',
            fontSmoothing: 'antialiased',
            fontWeight: '500',
            color: '#fff',
            '::placeholder': {
              color: '#adb5bd',
              opacity: '0.9 !important',
              fontWeight: '500',
              fontFamily: 'Open Sans, sans-serif',
            }
          },
          autofilled: {
            color: '#adb5bd'
          }
        }
      },
      cvv: {
        style: {
          base: {
            width: '100%',
            fontSize: '15px',
            fontFamily: 'Open Sans, sans-serif',
            lineHeight: '18px',
            fontSmoothing: 'antialiased',
            fontWeight: '500',
            color: '#fff',
            '::placeholder': {
              color: '#adb5bd',
              opacity: '0.9 !important',
              fontWeight: '500',
              fontFamily: 'Open Sans, sans-serif',
            }
          }
        },
        placeholder: translate(intl, 'Form.placeholder.cvv')
      }
    },
    default: {
      pan: {
        showIcon: true,
        style: {
          base: {
            fontSize: '14px',
            fontFamily: 'Quicksand, Open Sans, Segoe UI, sans-serif',
            lineHeight: '18px',
            fontSmoothing: 'antialiased',
            fontWeight: '500',
            color: '#666',
            '::placeholder': {
              color: '#aaaaaa',
              fontWeight: '400',
            },
            iconColor: '#000000'
          },
          autofilled: {
            color: '#000000'
          }
        },
        placeholder: translate(intl, 'Form.placeholder.pan')
      },
      expiration: {
        style: {
          base: {
            fontSize: '14px',
            fontFamily: 'Quicksand, Open Sans, Segoe UI, sans-serif',
            lineHeight: '18px',
            fontSmoothing: 'antialiased',
            fontWeight: '500',
            color: '#666',
            '::placeholder': {
              color: '#aaaaaa',
              fontWeight: '400',
            }
          },
          autofilled: {
            color: '#000000'
          }
        }
      },
      cvv: {
        style: {
          base: {
            width: '100%',
            fontSize: '14px',
            fontFamily: 'Quicksand, Open Sans, Segoe UI, sans-serif',
            lineHeight: '18px',
            fontSmoothing: 'antialiased',
            fontWeight: '500',
            color: '#666',
            '::placeholder': {
              color: '#aaaaaa',
              fontWeight: '400',
            }
          }
        },
        placeholder: translate(intl, 'Form.placeholder.cvv')
      }
    }
  }
};

export const delayShow = (id, delay) => () => {
  setTimeout(() => {
    const el = document.getElementById(id);
    if (el) el.style.display = 'block';
  }, delay);
}
